import React, { Component } from 'react'
import {
  Button,
  Form,
  Modal,
  Popconfirm,
  Input,
  Upload,
  Icon,
  message,
  Tree,
  Table,
  Divider
} from 'antd'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import Loader from '../../common/Loader'
import { actions } from '../../../redux/modules/jobFunctions/jobSiteDocumentActions'
import styled from 'styled-components'
import _ from 'lodash'

const FormItem = Form.Item
const { TextArea } = Input
const propTypes = {}
const TreeNode = Tree.TreeNode

const StyledActionContainer = styled.div`
  display: flex;
`

const StyledGoParentFolder = styled.div`
  background-color: #d9283b !important;
`

const CreatePathForm = Form.create()(
  class extends React.Component {
    render() {
      const {
        handleFolderCreate,
        handleFolderCancel,
        folderName,
        modalFolderVisible,
        folderId,
        form
      } = this.props
      const { getFieldDecorator } = form
      return (
        <Modal
          visible={modalFolderVisible}
          title="Add Folder"
          okText={folderId ? 'Save Changes' : 'Create'}
          onCancel={handleFolderCancel}
          onOk={handleFolderCreate}
          maskClosable={false}
        >
          <Form layout="vertical">
            <FormItem label="Folder Name">
              {getFieldDecorator('name', {
                rules: [
                  {
                    required: true,
                    message: 'Folder name cannot be blank.'
                  }
                ],
                initialValue: folderId ? folderName : ''
              })(
                <Input
                  placeholder="Type the folder name..."
                  initialvalue={folderId ? folderName : ''}
                />
              )}
            </FormItem>
          </Form>
        </Modal>
      )
    }
  }
)

class JobSiteDocuments extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentId: 0,
      contentFolder: null,
      content: null,
      fileList: [],
      treeData: null,
      showDocumentActions: false,
      showFolderActions: false
    }
    this.props.jobSiteDocumentsFetch({
      jobId: this.props.jobId
    })
  }

  showModal = () => {
    this.setState({
      modalVisible: true
    })
  }

  handleAddButton = () => {
    this.props.form.resetFields()
    this.setState({
      modalVisible: true,
      currentId: this.props.jobId,
      content: null
    })
  }

  handleAddFolderButton = () => {
    this.pathFormRef.props.form.resetFields()
    this.setState({
      modalFolderVisible: true
    })
  }

  handleCancel = () => {
    this.props.form.resetFields()
    this.setState({ data: [], currentId: 0, modalVisible: false, currentFileId: null })
  }

  handleFolderCancel = () => {
    this.pathFormRef.props.form.resetFields()
    this.setState({ data: [], currentId: 0, modalFolderVisible: false })
  }

  handleFolderCreate = () => {
    const form = this.pathFormRef.props.form

    form.validateFields((err, values) => {
      if (err) {
        return
      }

      if (this.state.folderId) {
        this.props.updateFolder({
          name: values.name,
          jobId: this.props.jobId,
          folderId: this.state.folderId,
          currentFolderId: this.state.currentFolderId
        })
      } else {
        this.props.createFolder({
          parentId: this.state.currentFolderId,
          jobId: this.props.jobId,
          name: values.name,
          folderId: this.state.currentFolderId
        })
      }

      message.success('Path created!')
    })

    this.pathFormRef.props.form.resetFields()
    this.setState({
      modalFolderVisible: false,
      pathEditId: null,
      selectedFolder: null
    })
  }

  uploadAttachment = uploadParam => {
    const form = this.props.form

    form.validateFields((err, values) => {
      if (err) {
        return
      }
      const formData = new FormData()

      formData.append('file', uploadParam.file)
      formData.append('type', 'job_site_document')
      formData.append('created_by_id', this.props.user.userId)
      formData.append('updated_by_id', this.props.user.userId)
      formData.append('filename', uploadParam.file.name)
      formData.append('description', uploadParam.file.name)
      if (this.state.currentFolderId) {
        formData.append('folderId', this.state.currentFolderId)
      }
      formData.append('jobId', this.props.jobId)

      this.props.uploadAttachment({
        formData: formData,
        jobId: this.props.jobId,
        folderId: this.state.currentFolderId
      })

      message.warning('Uploading file...')

      form.resetFields()
      this.setState({ modalVisible: false, currentFileId: null })
    })
  }

  updateAttachmentDescription = () => {
    const form = this.props.form

    form.validateFields((err, values) => {
      if (err) {
        return
      }

      this.props.updateJobSiteDocument({
        jobId: this.props.jobId,
        description: values.description,
        attachmentId: this.state.currentFileId,
        folderId: this.state.currentFolderId
      })
      message.success('Changes saved.')

      form.resetFields()
      this.setState({ modalVisible: false, currentFileId: null })
    })
  }

  onSelect = (selectedKeys, info) => {
    this.setState({
      selectedFolder: !info.selected ? {} : info.node.props,
      showDocumentActions: info.node.props.isLeaf && info.selected ? true : false,
      showFolderActions: info.node.props.isLeaf || !info.selected ? false : true
    })
  }

  renderTreeNodes = data => {
    return data.map(item => {
      const leaf = item.isLeaf ? true : false
      const filteredTitle = item.dbAttachment ? item.dbAttachment.description : item.path
      const filteredKey = item.dbAttachment ? item.dbAttachment.id : item.id
      if (item.children) {
        return (
          <TreeNode
            title={filteredTitle}
            key={filteredKey}
            dataRef={item}
            icon={leaf ? <Icon type={'file'} /> : <Icon type={'folder'} />}
            isLeaf={leaf}
          >
            {this.renderTreeNodes(item.children)}
          </TreeNode>
        )
      }
      return (
        <TreeNode
          {...item}
          title={filteredTitle}
          key={filteredKey}
          dataRef={item}
          icon={leaf ? <Icon type={'file'} /> : <Icon type={'folder'} />}
          isLeaf={leaf}
        />
      )
    })
  }

  handleDownloadButton = () => {
    if (this.state.selectedFolder && this.state.selectedFolder.signedUrl) {
      window.location.href = this.state.selectedFolder.signedUrl
    }
    this.setState({
      showDocumentActions: false
    })
  }

  savePathFormRef = pathFormRef => {
    this.pathFormRef = pathFormRef
  }

  // eslint-disable-next-line max-params
  onClickLineItem = (type, name, id, parentId, parentName, signedUrl) => {
    if (type === 'folder') {
      this.setState({
        currentFolderId: id,
        currentFolderName: name,
        parentFolderId: parentId,
        parentFolderName: parentName
      })

      this.props.jobSiteDocumentsFetch({
        jobId: this.props.jobId,
        folderId: id || parentId
      })
    } else {
      window.location.href = signedUrl
    }
  }

  handleEdit = (type, id, content) => {
    if (type === 'file') {
      this.setState({
        modalVisible: true,
        currentFileId: id,
        currentFileDescription: content
      })
    } else {
      this.pathFormRef.props.form.resetFields()
      this.setState({
        modalFolderVisible: true,
        folderId: id,
        folderName: content
      })
    }
  }

  handleDelete = (type, id) => {
    const form = this.props.form
    if (type === 'file') {
      this.props.deleteJobSiteDocument({
        jobId: this.props.jobId,
        attachmentId: id,
        folderId: this.state.currentFolderId
      })

      form.resetFields()
      message.success('Document deleted.')
      this.setState({
        content: null,
        currentId: 0,
        modalVisible: false
      })
    } else {
      this.props.deleteFolder({
        folderId: id,
        jobId: this.props.jobId,
        currentFolderId: this.state.currentFolderId
      })
      message.success('folder deleted!')
      this.setState({
        modalFolderVisible: false,
        pathEditId: null,
        showFolderActions: false,
        selectedFolder: null
      })
    }
  }

  getTableColumns = () => {
    return [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        render: item => {
          if (item['type'] === 'folder') {
            return (
              <a
                href="javascript:;"
                onClick={() =>
                  this.onClickLineItem(
                    item['type'],
                    item['name'],
                    item['id'],
                    item['parentId'],
                    item['parentName'],
                    item['signedUrl']
                  )
                }
              >
                <Icon type="folder" theme="filled" /> {item['name']}
              </a>
            )
          } else {
            return (
              <a href={item['signedUrl']} target="_blank">
                <Icon type="file" theme="filled" /> {item['name']}
              </a>
            )
          }
        }
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'age'
      },
      {
        title: 'Added by',
        dataIndex: 'added_by',
        key: 'address'
      },
      {
        title: 'Action',
        key: 'action',
        render: (text, record) => {
          const description =
            record.name['type'] === 'file' ? record.description : record.name['name']
          return (
            <span>
              <Icon
                type="edit"
                onClick={() => this.handleEdit(record.name['type'], record.name['id'], description)}
                theme="filled"
              />
              <Divider type="vertical" />
              <Popconfirm
                title="Are you sure you want to delete this record?"
                onConfirm={() => this.handleDelete(record.name['type'], record.name['id'])}
                okText="Yes"
                cancelText="No"
              >
                <Icon type="delete" theme="filled" />
              </Popconfirm>
            </span>
          )
        }
      }
    ]
  }

  getTableData = () => {
    const documentsAndFolders = _.get(this.props, 'jobSiteDocumentActions.documentsAndFolders.data')

    let data = []

    if (documentsAndFolders) {
      for (const item of documentsAndFolders) {
        let nameParam = []
        nameParam['type'] = item.type
        nameParam['name'] = item.name
        nameParam['id'] = item.id
        nameParam['parentId'] = item.parent_id
        nameParam['parentName'] = item.parent_name
        nameParam['signedUrl'] = item.signedUrl

        const itemObj = {
          name: nameParam,
          description: item.description,
          added_by: `${item.first_name} ${item.last_name}`
        }
        data.push(itemObj)
      }
    }

    return data
  }

  render() {
    const { currentFileId, currentFileDescription } = this.state

    const { getFieldDecorator } = this.props.form

    const loading = _.get(this.props, 'jobSiteDocumentActions.loading')

    const uploadProps = {
      multiple: true,
      fileList: this.state.fileList
    }

    if (loading) {
      return <Loader />
    }
    return (
      <div>
        <CreatePathForm
          wrappedComponentRef={this.savePathFormRef}
          folderName={this.state.folderName}
          handleFolderCreate={this.handleFolderCreate}
          handleFolderCancel={this.handleFolderCancel}
          confirmFolderDelete={this.confirmFolderDelete}
          cancelFolderDelete={this.cancelFolderDelete}
          folderId={this.state.folderId}
          modalFolderVisible={this.state.modalFolderVisible}
        />
        <Modal
          visible={this.state.modalVisible}
          title="Documents"
          okText={currentFileId ? 'Save Changes' : 'Create'}
          onCancel={this.handleCancel}
          onOk={this.updateAttachmentDescription}
        >
          <Form layout="vertical">
            {!currentFileId && (
              <div>
                <div>Upload File(s)</div>
                <br />
                <Upload {...uploadProps} name="file" customRequest={this.uploadAttachment}>
                  <Button>
                    <Icon type="upload" /> Upload
                  </Button>
                </Upload>
              </div>
            )}
            {currentFileId && (
              <FormItem label="Description">
                {getFieldDecorator('description', {
                  rules: [
                    {
                      required: true,
                      message: 'Note description cannot be blank.'
                    }
                  ],
                  initialValue: currentFileDescription ? currentFileDescription : ''
                })(
                  <TextArea
                    placeholder="Describe the attachment..."
                    rows={4}
                    initialvalue={currentFileDescription ? currentFileDescription : ''}
                  />
                )}
              </FormItem>
            )}
            <Popconfirm
              title="Are you sure you want to delete this record?"
              onConfirm={this.confirmDelete}
              onCancel={this.cancelDelete}
              okText="Yes"
              cancelText="No"
            >
              {currentFileId && <Button type="danger" icon="delete" />}
            </Popconfirm>
          </Form>
        </Modal>
        <div className="jobsBar">
          Documents
          <StyledActionContainer>
            {this.state.currentFolderName && (
              <StyledGoParentFolder className="jobsBarAdd">
                <div
                  onClick={() =>
                    this.onClickLineItem(
                      'folder',
                      this.state.parentFolderName,
                      this.state.parentFolderId,
                      null
                    )
                  }
                  className="addJobLabel"
                >
                  <Icon type="arrow-up" /> {this.state.currentFolderName}
                </div>
              </StyledGoParentFolder>
            )}

            <div className="jobsBarAdd">
              <i className="fa fa-file" aria-hidden="true" />
              &nbsp;<div onClick={() => this.handleAddButton()} className="addJobLabel">
                ADD Document
              </div>
            </div>
            <div className="jobsBarAdd">
              <i className="fa fa-folder" aria-hidden="true" />
              &nbsp;<div onClick={() => this.handleAddFolderButton()} className="addJobLabel">
                ADD Folder
              </div>
            </div>
          </StyledActionContainer>
        </div>
        {!loading && (
          <Table
            pagination={false}
            columns={this.getTableColumns()}
            dataSource={this.getTableData()}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = ({ jobSiteDocumentActions }, ownProps) => ({ jobSiteDocumentActions })
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(actions, dispatch)
})

JobSiteDocuments.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(JobSiteDocuments))
)



// WEBPACK FOOTER //
// ./src/containers/job/tasks/JobSiteDocuments.js